import "../Styles/ArtistAvatar.css";

type Props = {
  name: string;
  /** Används som frö istället för namnet när det finns, så en artist får
   *  samma färger även om namnet stavas om i katalogen. */
  seed?: string;
  size?: number;
  className?: string;
};

/**
 * Lokal placeholder för artister. Katalogen lagrar medvetet inga bilder, så
 * det här är allt vi visar — initialer på en gradient som räknas fram ur
 * namnet.
 *
 * Deterministiskt: samma artist får alltid samma färger, i alla vyer och
 * mellan sessioner, utan att något behöver lagras.
 */

function hash(value: string) {
  let h = 2166136261;

  for (let i = 0; i < value.length; i++) {
    h ^= value.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }

  return Math.abs(h);
}

function initials(name: string) {
  const words = name.trim().split(/\s+/).filter(Boolean);

  if (!words.length) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();

  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

export default function ArtistAvatar({ name, seed, size = 40, className }: Props) {
  const h = hash(seed || name);

  // Två närliggande toner ger en gradient som håller ihop istället för att
  // krocka, och håller sig inom appens mörka, mättade uttryck.
  const hue = h % 360;
  const hue2 = (hue + 40 + (h % 40)) % 360;

  return (
    <div
      className={["artist-avatar", className].filter(Boolean).join(" ")}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(9, Math.round(size * 0.36)),
        backgroundImage: `linear-gradient(135deg, hsl(${hue} 62% 42%), hsl(${hue2} 68% 26%))`,
      }}
      aria-hidden="true"
    >
      <span>{initials(name)}</span>
    </div>
  );
}
